import '@expo/metro-runtime';
import React, { lazy, Suspense } from 'react';
import { usePreventPageZoom } from 'src/hooks/usePreventPageZoom';
import { TRouteComponent } from './_shared/routes.types';
import { PageLoader } from '@photosi/rn-components/page-loader/PageLoader';

const UploadFamilyFriendsApp = lazy(() => import('src/screen/upload-family-friends/UploadFamilyFriendsApp'));

export const UploadFamilyFriendsRoute: TRouteComponent = ({ route }) => {
  usePreventPageZoom();

  return (
    <Suspense fallback={<PageLoader />}>
      <UploadFamilyFriendsApp token={route.params.shareToken} origin={route.params.origin} />
    </Suspense>
  );
};
